<template>
    <div class="app-main non-out">
        <div class="top-bar">
            <el-input  v-model="searchVal" placeholder="输入手机号/邮箱搜索" @change="search" style="width:240px" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-date-picker v-model="date" @change="handleDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width:260px;margin-left:20px"></el-date-picker>
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table :data="tableData"   height="560">
                <el-table-column prop="created_at" label="参与时间"  align="center"></el-table-column>
                <el-table-column prop="gift_info" label="中奖礼品图片"  align="center">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.gift_info.pic" :src="scope.row.gift_info.pic" />
                    </template>
                </el-table-column>
                <el-table-column prop="gift_info" label="中奖礼品名称"  align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.gift_info.title}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="phone" label="手机号" align="center">
                    <template slot-scope="scope">
                        <span>{{scope.row.phone}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="email" label="邮箱" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.email}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态"  align="center">
                    <template slot-scope="scope">
                        <span :style="{color:scope.row.status == '0'? '#ff4949' : '#28ca07'}">{{scope.row.status == '0' ? '未兑换' : '已兑换'}}</span>
                    </template>
                </el-table-column>
            </el-table>

             <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
        </el-card>
    </div>
</template>



<script>
import { record_list } from "@/api/market.js";
import MImg from "@/components/Image";
export default {
    components: { MImg },
    data() {
        return {
            searchVal:'',
            date:'',
            tableData:[],
            page: 1,
            total: 0,
            size: 20
        }
    },
    methods: {
        search() {
            this.date = ''
            this.page = 1
            this.getData();
        },
        handleDate() {
            this.searchVal = ''
            this.page = 1
            this.getData();
        },
        reloadData(page){
            this.page = page;
            this.getData();
        },
        getData() {
            let params = {
                page: this.page
            }
            
            if (this.searchVal != "") {
                params.search =  this.searchVal
            }
            if(this.date && this.date.length != 0){
                params.start_date_search = this.date[0];
                params.end_date_search = this.date[1];
            }
            record_list(params).then(res => {  
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size = res.data.per_page
                }
            })
        },
        // 领取
        getGift() {

        }
    },
    mounted(){
        this.getData()
    },
    activated() {
        this.getData()
    },

}
</script>
<style scoped>
.input-icon {
    width: 14px;
    height: 14px;
    margin: 13px 0 0 5px;
}
</style>

